import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={100}
    height={100}
    fill="none"
    {...props}
  >
    <path
      stroke="#D0D5DD"
      strokeWidth={4}
      d="M12.5 91.665h75c0-18.41-16.79-33.333-37.5-33.333S12.5 73.256 12.5 91.665ZM68.75 27.082c0 10.355-8.395 18.75-18.75 18.75s-18.75-8.395-18.75-18.75S39.645 8.332 50 8.332s18.75 8.395 18.75 18.75Z"
    />
  </svg>
)
export default SvgComponent
